export const CANVAS_MIN_BBOX_WIDTH = 0.00394 // 300m in EPSG 4326 coordinate system
export const POINT_MIN_BBOX_WIDTH = 0.00140 // ~110m in EPSG 4326 coordinate system
